import { render, staticRenderFns } from "./AnalyticsBankPay.vue?vue&type=template&id=ede4e25a&"
import script from "./AnalyticsBankPay.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsBankPay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports